import api from '@/apis/pa/pAStatisticalDayOffAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('pAStatisticalDayOff', api);

const state = {
  ...crud.state,
  _config: {
    table: 'pa_work_point',
    field: {
      key: 'ref_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
